import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  driverSalaryAdjustmentsCreate,
  driverSalaryAdjustmentsDetail,
  driverSalaryAdjustmentsEdit,
} from 'bus/driverSalaryAdjustments/actions';
import { DriverSalaryAdjustmentsItem } from 'bus/driverSalaryAdjustments/types';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

import { getDefaultFilter } from '../../utils';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  type: 'driver' | 'mixer' | 'employee';
};

const initialForm: DriverSalaryAdjustmentsItem = {
  id: null,
  comment: '',
  date: '',
  driverId: null,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, type }) => {
  const dispatch = useDispatchPromise();
  const [loading, setLoading] = useState(false);
  //const { data: adjustmentData } = useSelector((store: RootStore) => store.driverSalaryAdjustments.detail);

  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<DriverSalaryAdjustmentsItem>(initialForm);
  const storeEmployee: any = useMemo(() => {
    const defaultFilter = getDefaultFilter(type);

    const defaultSort = [{ selector: 'fullName', desc: false }];
    return $createDataSource('/v1/employee', 'id', { defaultFilter, defaultSort });
  }, [type]);

  const onShown = async () => {
    if (id) {
      const result = await dispatch(driverSalaryAdjustmentsDetail.async({ id }));
      setForm(result);
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await dispatch(driverSalaryAdjustmentsEdit.async(form));
      } else {
        const temp = { ...form };
        delete temp.id;
        await dispatch(driverSalaryAdjustmentsCreate.async({ ...temp }));
      }
      changeVisible(false);
      refresh();
    }
    setLoading(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Корректировка"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, date: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label={type === 'employee' ? 'Контрагент' : 'Водитель'} labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeEmployee}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.driverId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, driverId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Водитель" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Водитель" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
